<template>
  <div class="barrages-drop">
    <vue-baberrage :barrageList="barrageList"
                   :boxHeight="boxHeight"
                   :isShow="barrageIsShow"
                   :lanesCount="lanesCount"
                   :loop="barrageLoop"
                   :messageHeight="messageHeight"
                   :throttleGap="throttleGap">
    </vue-baberrage>
  </div>
</template>

<script>
import Vue from 'vue'
import { vueBaberrage, MESSAGE_TYPE } from 'vue-baberrage'
Vue.use(vueBaberrage)

export default {
  props: {
    danMuBox: {}
  },
  name: 'Barrages',
  data () {
    return {
      barrageList: [],
      barrageIsShow: true,    	//是否展示弹幕
      barrageLoop: true,     	//是否循环播放
      boxHeight: 50,         	//高度
      messageHeight: 40,		//消息高度
      lanesCount: 3,			//泳道数量
      throttleGap: 5000,		//消息间隔
    }
  },
  mounted () {
    this.addToList();
  },
  methods: {
    addToList () {
      let list = this.danMuBox;
      list.forEach((v) => {
        this.barrageList.push({
          id: v.id,					//弹幕ID
          // avatar: v.avatar,      		//头像
          msg: v.msg,             	//弹幕消息
          time: v.time,          		//屏幕展示时间
          type: MESSAGE_TYPE.NORMAL,	//类型
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
/*弹幕区域高度*/
/deep/ .baberrage-stage {
  height: 100%;
  width: 100%;
}

/*弹幕消息框*/
/deep/ .baberrage-item .normal {
  padding: 0;
  margin: 0;
  border-radius: 10px;
}

/*头像*/
/deep/ .baberrage-item .normal .baberrage-avatar {
  width: 0px;
  height: 0px;
}

/*文字*/
/deep/ .baberrage-item .normal .baberrage-msg {
  font-size:calc(100vw * 12 / 1920);
  line-height: none;
  padding: 0 0.5vh;
}

</style>